import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

export type SignUpDesign =
    'old' |
    'new' |
    'new_photo_last' |
    'new_skip_steps'

interface SignUpDesignStore {
    design: SignUpDesign;
    isUseABTest: boolean;
    setDesign: (design: SignUpDesign) => void;
}

export const useSignUpDesign = create<SignUpDesignStore>()(
    devtools(
        immer((set, _) => ({
            design: 'old',
            isUseABTest: true,
            setDesign:
                (design: SignUpDesign) =>
                    set({ design })
        }))
    )
);
